import { createContext } from 'react';
import { useHeadlessEditClientAssessment } from '../hooks/useHeadlessEditClientAssessment';

export interface EditAssessmentPageContextProps
  extends Pick<
    ReturnType<typeof useHeadlessEditClientAssessment>,
    | 'fieldInEditID'
    | 'setFieldInEditID'
    | 'updateHouseholdSummaryMarkdown'
    | 'updateMarkdownStrengthAtIndex'
    | 'updateMarkdownAreaForImprovementAtIndex'
    | 'updateElementMarkdownDetail'
    | 'defaultContent'
    | 'deleteMarkdownStrengthAtIndex'
    | 'deleteMarkdownAreaForImprovementAtIndex'
    | 'isAddingFinancialStrength'
    | 'isAddingAreaForImprovement'
    | 'toggleAddingFinancialStrength'
    | 'toggleAddingAreaForImprovement'
    | 'addFinancialStrengthForm'
    | 'addFinancialAreaOfImprovementForm'
    | 'isUpdating'
    | 'setIsAddingFinancialStrength'
    | 'setIsAddingAreaForImprovement'
    | 'strengthDeleteCandidateIndex'
    | 'areaDeleteCandidateIndex'
    | 'setStrengthDeleteCandidateIndex'
    | 'setAreaDeleteCandidateIndex'
    | 'updateDataConfidenceSummaryMarkdown'
    | 'updateDataConfidenceLevel'
  > {
  enabled: boolean;
  hideTooltips: boolean;
}

export const EditAssessmentPageContext = createContext<EditAssessmentPageContextProps | null>(null);
